module.exports = __webpack_public_path__ + "static/img/100781.473b42e7.png";